import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Monitor, MapPin, Languages, Briefcase, Palette, Music, Paintbrush, BookOpen } from 'lucide-react';

const categories = [
  {
    id: 1,
    name: 'Online Tuition',
    description: 'Learn from anywhere with expert online tutors',
    icon: Monitor,
    color: 'bg-[#041f96]',
    link: '/tuition-posts?mode=online',
  },
  {
    id: 2,
    name: 'Offline Tuition',
    description: 'In-person classes with local tutors near you',
    icon: MapPin,
    color: 'bg-emerald-600',
    link: '/tuition-posts?mode=offline',
  },
  {
    id: 3,
    name: 'Languages',
    description: 'Learn English, Hindi, French & more languages',
    icon: Languages,
    color: 'bg-orange-500',
    link: '/find-tutor?subject=Languages',
  },
  {
    id: 4,
    name: 'Tutoring Jobs',
    description: 'Explore teaching job opportunities across India',
    icon: Briefcase,
    color: 'bg-violet-600',
    link: '/find-job',
  },
  {
    id: 5,
    name: 'Arts & Craft',
    description: 'Discover creative arts and craft classes',
    icon: Palette,
    color: 'bg-pink-500',
    link: '/find-tutor?subject=Arts',
  },
  {
    id: 6,
    name: 'Paintings',
    description: 'Learn painting techniques from skilled artists',
    icon: Paintbrush,
    color: 'bg-amber-600',
    link: '/find-tutor?subject=Painting',
  },
  {
    id: 7,
    name: 'Music',
    description: 'Vocal, guitar, piano, drums and more',
    icon: Music,
    color: 'bg-rose-600',
    link: '/find-tutor?subject=Music',
  },
  {
    id: 8,
    name: 'Academics',
    description: 'Maths, Science, English and all school subjects',
    icon: BookOpen,
    color: 'bg-cyan-600',
    link: '/find-tutor',
  },
];

export const Categories = () => {
  const navigate = useNavigate();

  return (
    <div className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
            Browse by <span className="text-[#041f96]">Category</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore a wide range of learning categories and find what suits you best
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {categories.map((category) => {
            const Icon = category.icon;
            return (
              <div
                key={category.id}
                onClick={() => navigate(category.link)}
                className="group bg-white p-5 sm:p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-lg hover:border-[#041f96]/30 transition-all cursor-pointer"
              >
                <div className={`${category.color} w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className="h-6 w-6 sm:h-7 sm:w-7 text-white" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1">
                  {category.name}
                </h3>
                <p className="text-xs sm:text-sm text-gray-500 leading-relaxed">
                  {category.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
